import { getCustomerCareUrl } from 'lib/customerCareUrl';

export const stateError = {
  hasError: false,
  message: 'Generic error',
  section: '',
  code: { text: '404' },
  title: { text: 'Purtroppo questa pagina non è disponibile' },
  button: { text: 'Ricarica la pagina', style: { marginTop: '40px' } },
  problem: {
    text: 'Segnala il problema',
    get link() {
      return getCustomerCareUrl();
    },
  },
};
export const stateErrorLogout = {
  hasError: false,
  message: 'Generic error',
  section: '',
  code: { text: '404' },
  title: { text: 'Purtroppo questa pagina non è disponibile' },
  button: {
    text: 'Logout',
    link: '/rqx/session/logout',
    blank: false,
    style: { marginTop: '40px' },
  },
  problem: {
    text: 'Segnala il problema',
    get link() {
      return getCustomerCareUrl();
    },
  },
};
